import type { Theme } from '../../types/theme';

export const ibmTheme: Theme = {
  id: 'ibm',
  name: 'IBM',
  description: 'Carbon design system with structured blue palette for enterprise tech',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/ibm/DESIGN.md',
  visualKeywords: ['blue', 'carbon', 'structured', 'enterprise', 'technical'],
  colors: {
    background: '#ffffff',
    surface: '#f4f4f4',
    surfaceElevated: '#f4f4f4',
    textPrimary: '#171717',
    textSecondary: '#525252',
    textMuted: '#525252',
    border: '#e0e0e0',
    borderSubtle: '#d6d6d6',
    primary: '#4267ff',
    primaryHover: '#5176ff',
    primaryActive: '#2449e1',
    accent: '#4267ff',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'professional',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
